export default {
  markets: {
    id: 'bo_seller-options-shipping-method_list-markets',
    defaultMessage: 'Market(s)',
  },
  states: {
    id: 'bo_seller-options-shipping-method_list-states',
    defaultMessage: 'States',
  },
  preparationTime: {
    id: 'bo_seller-options-shipping-method_list-preparation_time',
    defaultMessage: 'Prep time',
  },
  totalTime: {
    id: 'bo_seller-options-shipping-method_list-total_time',
    defaultMessage: 'Total until delivery',
  },
} as const
